/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntercomTokenDto } from '../models/IntercomTokenDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IntercomService {

    /**
     * Retrieve Intercom auth token
     * @returns IntercomTokenDto Successfully retrieved Intercom auth token
     * @throws ApiError
     */
    public static getIntercomAuthToken(): CancelablePromise<IntercomTokenDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/intercom/token',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
